import { render, staticRenderFns } from "./ChartBellCurve.vue?vue&type=template&id=64243122&"
import script from "./ChartBellCurve.vue?vue&type=script&lang=js&"
export * from "./ChartBellCurve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports